"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForAccessToken = void 0;
const constants_1 = require("../utils/constants");
const listenForAccessToken = ({ authUrl = constants_1.triaAuthUrl }) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const listener = (event) => {
            if (event.origin !== authUrl)
                return;
            let eventData;
            try {
                eventData = JSON.parse(event.data);
            }
            catch (err) { }
            if ((eventData === null || eventData === void 0 ? void 0 : eventData.type) == constants_1.eventTypes.accessToken) {
                localStorage.setItem('tria.accessToken', eventData === null || eventData === void 0 ? void 0 : eventData.data);
                window.removeEventListener('message', listener);
                resolve(true);
            }
        };
        window.addEventListener('message', listener);
    });
});
exports.listenForAccessToken = listenForAccessToken;
